module.exports = __webpack_public_path__ + "img/组 3.90fe206e.webp";